import React, { useState } from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon, SparklesIcon, CheckCircle2Icon } from 'lucide-react';
type PlanType = 'inicial' | 'mentoria';
export function OfferSection() {
  const [selectedPlan, setSelectedPlan] = useState<PlanType>('mentoria');
  return <section id="oferta" className="px-4 py-16 bg-[#0f0f10]" data-id="element-159">
      <div className="max-w-[720px] mx-auto" data-id="element-160">
        <h2 className="mb-2 text-3xl font-bold text-center md:text-4xl text-white font-sans" data-id="element-161">
          Elegí tu{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-amber" data-id="element-162">
            MegaPack Tarot
          </span>
          :
        </h2>
        <p className="mb-8 text-center text-brand-dark/60 text-lg font-sans" data-id="element-163">
          Las dos opciones incluyen acceso inmediato y bonos completos
        </p>

        <div className="flex flex-col gap-4 mb-6" data-id="element-164">
          {/* Card 1 - Inicial */}
          <div onClick={() => setSelectedPlan('inicial')} className={`relative p-5 md:p-6 rounded-2xl cursor-pointer transition-all duration-300 border ${selectedPlan === 'inicial' ? 'bg-[#1a1a1c] border-brand-teal/50 shadow-[0_0_15px_rgba(168,85,247,0.1)]' : 'bg-[#141415] border-white/5 hover:border-white/10 hover:bg-[#1a1a1c]'}`} data-id="element-165">
            <div className="flex items-start gap-4" data-id="element-166">
              <div className="flex-shrink-0 mt-1" data-id="element-167">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPlan === 'inicial' ? 'border-brand-teal' : 'border-white/20'}`} data-id="element-168">
                  {selectedPlan === 'inicial' && <div className="w-3 h-3 rounded-full bg-brand-teal" data-id="element-169" />}
                </div>
              </div>

              <div className="flex-1" data-id="element-170">
                <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2 mb-1" data-id="element-171">
                  <div data-id="element-172">
                    <h3 className="text-lg font-bold text-white font-sans" data-id="element-173">
                      MEGAPACK TAROT INICIAL
                    </h3>
                    <p className="text-sm text-brand-dark/60 mt-1 font-sans" data-id="element-174">
                      Acceso al megapack base + bonos
                    </p>
                  </div>
                  <div className="text-left md:text-right" data-id="element-175">
                    <div className="text-sm text-brand-dark/40 line-through font-sans" data-id="element-176">
                      $34.990
                    </div>
                    <div className="text-2xl font-bold text-white font-sans" data-id="element-177">
                      $19.990
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 - Mentoría */}
          <div onClick={() => setSelectedPlan('mentoria')} className={`relative p-5 md:p-6 rounded-2xl cursor-pointer transition-all duration-300 border-2 ${selectedPlan === 'mentoria' ? 'bg-brand-tealLight/40 border-brand-teal shadow-[0_0_25px_rgba(168,85,247,0.2)]' : 'bg-[#141415] border-white/5 hover:border-white/10 hover:bg-[#1a1a1c]'}`} data-id="element-178">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-179">
              <span className="px-3 py-1 text-[10px] md:text-xs font-bold uppercase tracking-wider text-white bg-gradient-to-r from-brand-teal to-brand-amber rounded-full shadow-lg flex items-center gap-1 whitespace-nowrap" data-id="element-180">
                <SparklesIcon className="w-3 h-3" data-id="element-181" />
                MÁS ELEGIDO
              </span>
              <span className="px-3 py-1 text-[10px] md:text-xs font-bold uppercase tracking-wider text-brand-teal bg-brand-teal/10 border border-brand-teal/30 rounded-full whitespace-nowrap hidden sm:inline-block" data-id="element-182">
                AHORRÁS $16.000
              </span>
            </div>

            <div className="flex items-start gap-4 mt-2" data-id="element-183">
              <div className="flex-shrink-0 mt-1" data-id="element-184">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPlan === 'mentoria' ? 'border-brand-teal' : 'border-white/20'}`} data-id="element-185">
                  {selectedPlan === 'mentoria' && <div className="w-3 h-3 rounded-full bg-brand-teal" data-id="element-186" />}
                </div>
              </div>

              <div className="flex-1" data-id="element-187">
                <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2 mb-2" data-id="element-188">
                  <div className="pr-0 md:pr-4" data-id="element-189">
                    <h3 className="text-lg font-bold text-white font-sans" data-id="element-190">
                      MEGAPACK TAROT INICIAL + MENTORÍA TAROT PRO™
                    </h3>
                    <span className="px-2 py-0.5 mt-2 text-[10px] font-bold uppercase tracking-wider text-brand-teal bg-brand-teal/10 border border-brand-teal/30 rounded-full inline-block sm:hidden mb-1" data-id="element-191">
                      AHORRÁS $16.000
                    </span>
                    <p className="text-sm text-brand-dark/70 mt-1 font-sans leading-relaxed" data-id="element-192">
                      Incluye el megapack inicial + mentoría para aplicar,
                      vender y profesionalizar tu servicio
                    </p>
                  </div>
                  <div className="text-left md:text-right flex-shrink-0" data-id="element-193">
                    <div className="text-sm text-brand-dark/40 line-through font-sans" data-id="element-194">
                      $43.990
                    </div>
                    <div className="text-3xl font-bold text-brand-teal font-sans" data-id="element-195">
                      $27.990
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex flex-col items-center" data-id="element-196">
          <a href={selectedPlan === 'mentoria' ? 'https://conversionelite.online/checkouts/cn/hWNBGO1OcH0mUfnyo4rbKnD8/es-ar?_r=AQAB9xe9TnyMmEOI5Q4FaO92qLQnj0qoUnQCXbY7Q9V4&cart_link_id=OS9zgSbd&preview_theme_id=161237270764' : 'https://conversionelite.online/checkouts/cn/hWNBGNeB5280Xjt2mvbeoCoc/es-ar?_r=AQABQGhPBp-DRdoCbfiR9cQ_LzOix6Y27NOEN-kTbYsewCU&cart_link_id=tVloLy3p&preview_theme_id=161237270764'} target="_blank" rel="noopener noreferrer" className="w-full py-5 px-6 text-base md:text-lg font-bold text-white text-center transition-all duration-300 bg-gradient-to-r from-brand-teal to-brand-amber rounded-xl hover:shadow-[0_0_30px_rgba(168,85,247,0.4)] hover:-translate-y-1 font-sans" data-id="element-197">
            {selectedPlan === 'mentoria' ? '→ SÍ, QUIERO EL MEGAPACK + MENTORÍA TAROT PRO™' : 'Quiero el MegaPack 🔮'}
          </a>

          <p className="mt-4 text-sm font-medium text-brand-dark/50 italic font-sans text-center" data-id="element-198">
            La opción más elegida por quienes quieren avanzar más rápido y
            cobrar mejor
          </p>
        </div>

        {/* Trust badges */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4 md:gap-8 pt-6 border-t border-white/5" data-id="element-199">
          <div className="flex items-center gap-2 text-brand-dark/60" data-id="element-200">
            <LockIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-201" />
            <span className="text-xs md:text-sm font-medium font-sans" data-id="element-202">
              Pago seguro
            </span>
          </div>
          <div className="flex items-center gap-2 text-brand-dark/60" data-id="element-203">
            <ZapIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-204" />
            <span className="text-xs md:text-sm font-medium font-sans" data-id="element-205">
              Acceso inmediato
            </span>
          </div>
          <div className="flex items-center gap-2 text-brand-dark/60" data-id="element-206">
            <ShieldCheckIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-207" />
            <span className="text-xs md:text-sm font-medium font-sans" data-id="element-208">
              Garantía 7 días
            </span>
          </div>
          <div className="flex items-center gap-2 text-brand-dark/60" data-id="element-209">
            <CreditCardIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-210" />
            <span className="text-xs md:text-sm font-medium font-sans" data-id="element-211">
              Mercado Pago
            </span>
          </div>
        </div>
      </div>
    </section>;
}